import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, MessageSquare, Mail } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../data/contact";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-gray-900 bg-black mt-16 sm:mt-24"
    >
      <div className="px-5 sm:px-8 md:px-12 lg:px-20 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo size="md" testId="footer-logo" />
            <p className="mt-8 text-sm font-light tracking-wide text-gray-400 leading-relaxed max-w-md">
              Premium mobile auto detailing in {CONTACT.city}. I bring water,
              power and the attention of a workshop directly to your driveway.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-500 mb-6">
              Explore
            </h4>
            <ul className="space-y-3">
              {[
                ["/services", "Services"],
                ["/pricing", "Pricing"],
                ["/about", "About"],
                ["/contact", "Contact"],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={to}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-xs font-light uppercase tracking-[0.2em] text-gray-400 hover:text-white transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-500 mb-6">
              Direct
            </h4>
            <div className="space-y-4">
              <a
                href={CONTACT.smsHref}
                data-testid="footer-phone"
                className="group inline-flex items-center gap-3 text-xs font-light uppercase tracking-[0.2em] text-gray-300 hover:text-white transition-colors"
              >
                <MessageSquare strokeWidth={1} size={16} />
                Text {CONTACT.phone}
              </a>
              <a
                href={CONTACT.emailHref}
                data-testid="footer-email"
                className="block group items-center gap-3 text-xs font-light tracking-[0.05em] text-gray-300 hover:text-white transition-colors break-all"
              >
                <span className="inline-flex items-center gap-3">
                  <Mail strokeWidth={1} size={16} />
                  {CONTACT.email}
                </span>
              </a>
              <a
                href={CONTACT.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="group inline-flex items-center gap-3 text-xs font-light uppercase tracking-[0.2em] text-gray-300 hover:text-white transition-colors"
              >
                <Instagram strokeWidth={1} size={16} />
                {CONTACT.instagram}
              </a>
              <div className="flex items-center gap-3 text-xs font-light uppercase tracking-[0.2em] text-gray-400">
                <MapPin strokeWidth={1} size={16} />
                {CONTACT.serviceArea}
              </div>
              <Link
                to="/contact"
                data-testid="footer-cta-quote"
                className="mt-4 inline-flex items-center px-6 py-3 border border-gray-700 text-[11px] font-display font-light uppercase tracking-[0.25em] text-gray-200 hover:border-white hover:text-white transition-all"
              >
                Request a quote →
              </Link>
            </div>
          </div>
        </div>

        <div className="hairline mt-14 mb-8" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-600">
            © {new Date().getFullYear()} SPINLAB Auto Detailing — Mobile Service
          </p>
          <p className="text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-600">
            No Shortcuts · Safe Products · Attention to Detail
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
